import { rpmAction } from "../actions/rpmAction";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isRPMViewLoading: false,
};

const rpm = createSlice({
  name: "rpm",
  initialState,
  reducers: rpmAction,
});

export const { setIsRPMViewLoading } = rpm.actions;

export default rpm.reducer;
